/* FT GUYS - shared theme JS (load once in theme.liquid with defer)
   1. Ink-strike scroll reveals  [data-ft-reveal] / [data-ft-panel]
   1b. Auto staggered reveals for cards and cells
   2. Anime reveal videos        autoplay on scroll, every device + a play control
   3. AJAX add-to-cart + fly-to-cart animation  [data-ft-add]
   4. Quick-view modal           click a chapter card's photo
*/
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function noop() {}

  var style = document.createElement('style');
  style.textContent =
    '[data-ft-reveal],[data-ft-auto-reveal]{opacity:0;transform:translate3d(0,22px,0);' +
    'transition:opacity .55s cubic-bezier(.22,1,.36,1),transform .72s cubic-bezier(.22,1,.36,1);}' +
    '[data-ft-reveal].is-in,[data-ft-auto-reveal].is-in{opacity:1;transform:none;}' +
    '[data-ft-auto-reveal].ft-pending{will-change:opacity,transform;}' +
    /* the clip fades back to the product over .45s rather than cutting */
    '.ft-chapter__media video,.ft-grid__media video,.ft-spot__media video{transition:opacity .45s ease !important;}' +
    '.ft-replay{position:absolute;bottom:8px;right:8px;z-index:5;width:44px;height:44px;' +
      'display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;' +
      'background:rgba(7,6,5,.78);border:1px solid rgba(245,239,232,.28);' +
      '-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);' +
      'opacity:0;transition:opacity .25s ease,border-color .2s ease;}' +
    '.ft-replay:hover{border-color:#ff5c1a;}' +
    '.ft-replay:focus-visible{opacity:1;outline:2px solid #ff5c1a;outline-offset:2px;}' +
    '.ft-replay-icon{width:0;height:0;border-block:6px solid transparent;border-inline-start:10px solid #f5efe8;margin-left:2px;}' +
    '.ft-replay:hover .ft-replay-icon{border-inline-start-color:#ff5c1a;}' +
    '.ft-replay.is-offer{opacity:1;border-color:#ff5c1a;}' +
    '.ft-replay.is-busy{opacity:0 !important;pointer-events:none;}' +
    '.ft-replay.is-wait .ft-replay-icon{width:11px;height:11px;border:2px solid rgba(245,239,232,.28);' +
      'border-top-color:#ff5c1a;border-radius:50%;margin:0;animation:ftSpin .8s linear infinite;}' +
    '@keyframes ftSpin{to{transform:rotate(360deg);}}' +
    '.ft-has-replay .ft-chapter__chip,.ft-has-replay .ft-grid__chip{display:none !important;}' +
    '@media (hover:none),(pointer:coarse){.ft-replay{opacity:1;}}' +
    '@media (hover:hover){[data-ft-card]:hover .ft-replay,.ft-grid__card:hover .ft-replay{opacity:1;}}' +
    '@media (prefers-reduced-motion:reduce){[data-ft-reveal],[data-ft-auto-reveal]{opacity:1;transform:none;transition:none;}' +
      '.ft-replay{opacity:1;}.ft-replay.is-wait .ft-replay-icon{animation:none;}}';
  document.head.appendChild(style);

  /* ---------- 1. scroll reveals ---------- */
  function initReveals(scope) {
    var els = (scope || document).querySelectorAll('[data-ft-reveal]:not(.is-in), [data-ft-panel]:not(.is-in)');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 1b. auto staggered reveals ---------- */
  var AUTO = [
    { sel: '.ft-worlds__cell', stagger: 55 },
    { sel: '.ft-chapter__card', stagger: 45 },
    { sel: '.ft-grid__card', stagger: 45 },
    { sel: '.ft-chapter__specs > div', stagger: 60 }
  ];
  var PROMOTE = ['.ft-worlds__grid', '.ft-chapter__specs'];
  var autoIO = null, queue = [], flushing = false;

  function flush() {
    flushing = false;
    var batch = queue.slice();
    queue.length = 0;
    batch.forEach(function (item, idx) {
      var delay = Math.min(idx, 5) * item.stagger;
      item.el.style.transitionDelay = delay + 'ms';
      item.el.classList.add('is-in');
      setTimeout(function () {
        item.el.classList.remove('ft-pending');
        item.el.style.transitionDelay = '';
      }, delay + 900);
    });
  }
  function enqueue(el, stagger) {
    queue.push({ el: el, stagger: stagger });
    if (flushing) return;
    flushing = true;
    requestAnimationFrame(flush);
  }
  function initAutoReveals(scope) {
    var root = scope || document;
    PROMOTE.forEach(function (sel) {
      var nodes = root.querySelectorAll ? root.querySelectorAll(sel + '[data-ft-reveal]') : [];
      nodes.forEach(function (c) { c.removeAttribute('data-ft-reveal'); c.classList.add('is-in'); });
    });
    if (reduced || !('IntersectionObserver' in window)) return;
    if (!autoIO) {
      autoIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          autoIO.unobserve(e.target);
          enqueue(e.target, Number(e.target.dataset.ftStagger) || 50);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    AUTO.forEach(function (rule) {
      var nodes = root.querySelectorAll ? root.querySelectorAll(rule.sel) : [];
      nodes.forEach(function (el) {
        if (el.hasAttribute('data-ft-auto-reveal')) return;
        if (el.closest('[data-ft-reveal]:not(.is-in)')) return;
        el.setAttribute('data-ft-auto-reveal', '');
        el.classList.add('ft-pending');
        el.dataset.ftStagger = String(rule.stagger);
        autoIO.observe(el);
      });
    });
  }

  /* ---------- 2. reveal videos ----------

     ENDING: the clip ALWAYS returns to the product. It used to freeze on its last
     frame whenever custom.reveal_color was unset - which is every product right now
     - so the card was left showing a stalled video still instead of the photo it
     started from. The hold made sense only on the assumption the metafield would be
     filled; leaving it as the default meant the common case was the broken one.

     Now: if reveal_color IS set, the matching colourway photo is swapped in first
     and the clip fades over it, so the card lands on the colour just shown. If it
     is NOT set, the clip simply fades back to the original photo. Either way the
     video ends on a product image, and either way it fades rather than cuts.

     PLAYS EVERYWHERE: autoplay is driven by scroll on every device (hover is an
     extra trigger, not the only one); a clip qualifies on 40% of itself being
     visible OR filling half the screen, so a card taller than the viewport is not
     silently skipped; playback waits for canplay with no deadline, so a slow
     connection is slow rather than broken; and a refused autoplay is retried on the
     first user gesture. iOS Low Power Mode still refuses outright - which is why
     the play button always exists and lights up.
  */
  var refused = [];

  // fade the clip out so whatever photo is underneath comes back
  function backToProduct(video) {
    video.classList.remove('is-held');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { video.classList.remove('is-playing'); });
    });
  }

  function settleAfterReveal(video) {
    var card = video.closest('[data-ft-card]') || video.closest('.ft-grid__card');
    var src = card && card.getAttribute('data-ft-reveal-src');
    var img = card && card.querySelector('[data-ft-photo]');

    var btn = addReplay(video);
    if (btn) {
      btn.classList.remove('is-busy', 'is-offer', 'is-wait');
      btn.setAttribute('aria-label', 'Play the reveal again');
    }

    // no colourway to land on: fade straight back to the photo already there
    if (!src || !img) { backToProduct(video); return; }

    // swap in the revealed colourway UNDER the clip, then fade the clip away
    var pre = new Image();
    pre.decoding = 'async';
    pre.src = src;
    var ready = pre.decode ? pre.decode().catch(noop) : Promise.resolve();
    Promise.race([ready, new Promise(function (r) { setTimeout(r, 600); })]).then(function () {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = src;
      backToProduct(video);
    });
  }

  function addReplay(video, offer) {
    var media = video.parentElement;
    if (!media) return null;
    var existing = media.querySelector('.ft-replay');
    if (existing) {
      if (offer) existing.classList.add('is-offer');
      return existing;
    }

    var btn = document.createElement('button');
    btn.className = 'ft-replay' + (offer ? ' is-offer' : '');
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Play the reveal');
    var icon = document.createElement('span');
    icon.className = 'ft-replay-icon';
    icon.setAttribute('aria-hidden', 'true');
    btn.appendChild(icon);

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      btn.classList.remove('is-offer');
      replay(video);
    });

    media.appendChild(btn);
    media.classList.add('ft-has-replay');
    return btn;
  }

  function btnFor(video) {
    return video.parentElement && video.parentElement.querySelector('.ft-replay');
  }

  function prime(video) {
    if (video.dataset.ftPrimed) return;
    video.dataset.ftPrimed = '1';
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    if (video.preload === 'none' || !video.preload) {
      video.preload = 'metadata';
      try { video.load(); } catch (e) {}
    }
  }

  function whenPlayable(video, cb) {
    if (video.readyState >= 3) { cb(); return; }
    var done = false;
    var EVENTS = ['canplay', 'canplaythrough', 'loadeddata'];
    function off() {
      EVENTS.forEach(function (ev) { video.removeEventListener(ev, go); });
      video.removeEventListener('error', fail);
    }
    function go() { if (done) return; done = true; off(); cb(); }
    function fail() {
      if (done) return;
      done = true; off();
      var b = btnFor(video);
      if (b) b.remove();
      delete video.dataset.ftTrying;
    }
    EVENTS.forEach(function (ev) { video.addEventListener(ev, go); });
    video.addEventListener('error', fail, { once: true });
    if (video.preload !== 'auto') {
      video.preload = 'auto';
      try { video.load(); } catch (e) {}
    }
  }

  function attempt(video) {
    var btn = btnFor(video);
    video.classList.add('is-playing');
    if (btn) { btn.classList.remove('is-wait'); btn.classList.add('is-busy'); }

    var p;
    try { p = video.play(); } catch (e) { p = null; }
    if (!p || !p.then) return;

    p.then(function () {
      video.dataset.ftPlayed = '1';
      var i = refused.indexOf(video);
      if (i > -1) refused.splice(i, 1);
    }).catch(function () {
      video.classList.remove('is-playing');
      delete video.dataset.ftPlayed;
      delete video.dataset.ftTrying;
      if (btn) btn.classList.remove('is-busy');
      addReplay(video, true);
      if (refused.indexOf(video) === -1) refused.push(video);
    });
  }

  function playOnce(video) {
    if (!video || video.dataset.ftPlayed || video.dataset.ftTrying) return;
    video.dataset.ftTrying = '1';
    prime(video);

    if (!video.dataset.ftBound) {
      video.dataset.ftBound = '1';
      video.addEventListener('ended', function () { settleAfterReveal(video); });
      video.addEventListener('waiting', function () {
        var b = btnFor(video);
        if (b) { b.classList.remove('is-busy'); b.classList.add('is-wait'); }
      });
      video.addEventListener('playing', function () {
        var b = btnFor(video);
        if (b) { b.classList.remove('is-wait'); b.classList.add('is-busy'); }
      });
    }

    if (video.readyState >= 3) { attempt(video); return; }
    var b = btnFor(video);
    if (b) b.classList.add('is-wait');
    whenPlayable(video, function () { attempt(video); });
  }

  function replay(video) {
    delete video.dataset.ftPlayed;
    delete video.dataset.ftTrying;
    video.classList.remove('is-held');
    prime(video);
    try { video.currentTime = 0; } catch (err) {}
    playOnce(video);
  }

  function inView(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom > 0 && r.top < vh;
  }

  var gestureUsed = false;
  function onFirstGesture() {
    if (gestureUsed) return;
    gestureUsed = true;
    refused.slice().forEach(function (v) { if (inView(v)) replay(v); });
  }
  ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, onFirstGesture, { once: true, passive: true });
  });

  function initRevealVideos(scope) {
    var vids = (scope || document).querySelectorAll('[data-ft-reveal-video]:not([data-ft-wired])');
    if (!vids.length) return;

    var warmIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        warmIO.unobserve(e.target);
        prime(e.target);
      });
    }, { rootMargin: '400px 0px' }) : null;

    var playIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var big = e.intersectionRect.height >= vh * 0.5;
        if (e.intersectionRatio >= 0.4 || big) {
          playIO.unobserve(e.target);
          playOnce(e.target);
        }
      });
    }, { threshold: [0, 0.4] }) : null;

    vids.forEach(function (v) {
      v.dataset.ftWired = '1';
      addReplay(v);
      var card = v.closest('[data-ft-card]') || v.closest('.ft-grid__card') || v.parentElement;

      if (warmIO) warmIO.observe(v);
      else prime(v);

      if (reduced) return;

      if (playIO) playIO.observe(v);
      else playOnce(v);

      if (card) card.addEventListener('mouseenter', function () { playOnce(v); });
    });
  }

  document.addEventListener('pointerdown', function (e) {
    var btn = e.target.closest && e.target.closest('.ft-replay');
    if (btn) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  /* ---------- 3. add-to-cart + fly animation ---------- */
  function flyToCart(fromEl, imgSrc) {
    var cartIcon = document.querySelector('cart-icon, [data-ft-cart-icon], a[href*="/cart"], cart-drawer-toggle, .header__icon--cart');
    if (!cartIcon || reduced) return Promise.resolve();
    var a = fromEl.getBoundingClientRect(), b = cartIcon.getBoundingClientRect();
    var el = document.createElement('img');
    el.src = imgSrc;
    el.alt = '';
    el.style.cssText = 'position:fixed;z-index:9999;width:84px;height:84px;object-fit:cover;left:' + a.left + 'px;top:' + a.top + 'px;pointer-events:none;box-shadow:0 0 40px rgba(255,92,26,.55);';
    document.body.appendChild(el);
    var x0 = a.left, y0 = a.top, x1 = b.left + b.width / 2 - 42, y1 = b.top + b.height / 2 - 42;
    var cx = (x0 + x1) / 2, cy = Math.min(y0, y1) - 160;
    var t0 = performance.now(), DUR = 1300;
    function ease(t){ return t<.5 ? 2*t*t : 1-Math.pow(-2*t+2,2)/2; }
    return new Promise(function (resolve) {
      (function step(now) {
        var t = Math.min(1, (now - t0) / DUR), e = ease(t), u = 1 - e;
        var x = u*u*x0 + 2*u*e*cx + e*e*x1;
        var y = u*u*y0 + 2*u*e*cy + e*e*y1;
        el.style.transform = 'translate(' + (x - x0) + 'px,' + (y - y0) + 'px) scale(' + (1 - e * .6) + ') rotate(' + (-7 + 11 * e) + 'deg)';
        if (t < 1) requestAnimationFrame(step);
        else {
          el.remove();
          cartIcon.animate([
            { transform: 'scale(1)' }, { transform: 'scale(1.28)' },
            { transform: 'scale(.96)' }, { transform: 'scale(1)' }
          ], { duration: 450, easing: 'ease-out' });
          resolve();
        }
      })(t0);
    });
  }
  function toast(msg) {
    var el = document.createElement('div');
    el.textContent = msg;
    el.setAttribute('role', 'status');
    el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:9999;background:#14100b;border:1px solid #ff5c1a;color:#f5efe8;font:700 13px Archivo,sans-serif;letter-spacing:.06em;padding:12px 18px;';
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 2000);
  }
  function notifyCartUpdated(cart, sourceId) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId: sourceId || 'ft-guys', data: { itemCount: cart.item_count, source: 'ft-guys' } }
    }));
  }

  function initAddButtons(scope) {
    (scope || document).querySelectorAll('[data-ft-add]:not([data-ft-wired])').forEach(function (btn) {
      btn.dataset.ftWired = '1';
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-ft-card]');
        var sizeBtn = card && card.querySelector('.ft-chapter__size.is-on');
        var variantId = sizeBtn && sizeBtn.getAttribute('data-ft-variant');
        if (!variantId) {
          toast('Pick a size first.');
          var group = card && card.querySelector('[data-ft-sizes]');
          if (group) {
            var firstSize = group.querySelector('.ft-chapter__size:not([disabled])');
            if (firstSize && firstSize.focus) firstSize.focus();
          }
          return;
        }
        btn.disabled = true;
        var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          var img = card.querySelector('[data-ft-photo]');
          var p = img ? flyToCart(img, img.currentSrc || img.src) : Promise.resolve();
          return p.then(function () {
            toast((btn.getAttribute('data-product-title') || 'Added') + ' - yours now.');
            return fetch(root + 'cart.js').then(function (r) { return r.json(); })
              .then(function (cart) { notifyCartUpdated(cart); });
          });
        }).catch(function () {
          toast('Something slipped. Try again - no rush.');
        }).finally(function () { btn.disabled = false; });
      });
    });
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.ft-chapter__size');
    if (!pill || pill.disabled) return;
    var group = pill.closest('[data-ft-sizes]');
    if (!group) return;
    group.querySelectorAll('.ft-chapter__size').forEach(function (b) {
      b.classList.remove('is-on');
      b.setAttribute('aria-pressed', 'false');
    });
    pill.classList.add('is-on');
    pill.setAttribute('aria-pressed', 'true');
  });

  /* ---------- 4. quick-view modal ---------- */
  var qvModal, qvLastFocus;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function buildQvShell() {
    qvModal = document.createElement('div');
    qvModal.className = 'ft-qv';
    qvModal.hidden = true;
    qvModal.innerHTML =
      '<div class="ft-qv__backdrop" data-ft-qv-close></div>' +
      '<div class="ft-qv__panel" role="dialog" aria-modal="true" aria-label="Quick view">' +
        '<button class="ft-qv__close" type="button" data-ft-qv-close aria-label="Close">&times;</button>' +
        '<div class="ft-qv__grid" data-ft-card></div>' +
      '</div>';
    document.body.appendChild(qvModal);
    qvModal.addEventListener('click', function (e) { if (e.target.closest('[data-ft-qv-close]')) closeQv(); });
    document.addEventListener('keydown', function (e) {
      if (!qvModal || qvModal.hidden) return;
      if (e.key === 'Escape') { closeQv(); return; }
      if (e.key !== 'Tab') return;
      var panel = qvModal.querySelector('.ft-qv__panel');
      var items = Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE))
        .filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  var qvScrollY = 0;
  function lockScroll() {
    qvScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = (-qvScrollY) + 'px';
    document.body.classList.add('ft-locked');
  }
  function unlockScroll() {
    document.body.classList.remove('ft-locked');
    document.body.style.top = '';
    window.scrollTo(0, qvScrollY);
  }
  function closeQv() {
    if (!qvModal) return;
    qvModal.hidden = true;
    qvModal.querySelector('.ft-qv__grid').innerHTML = '';
    unlockScroll();
    if (qvLastFocus && qvLastFocus.focus) qvLastFocus.focus();
  }
  function openQv(card) {
    var info = card.querySelector('.ft-chapter__info');
    if (!info) return false;
    if (!qvModal) buildQvShell();
    var grid = qvModal.querySelector('.ft-qv__grid');
    var photo = card.querySelector('[data-ft-photo]');
    grid.innerHTML = '';
    var left = document.createElement('div');
    left.className = 'ft-qv__photo';
    if (photo) {
      var im = new Image();
      im.src = photo.currentSrc || photo.src;
      im.alt = '';
      im.setAttribute('data-ft-photo', '');
      left.appendChild(im);
    }
    var right = document.createElement('div');
    right.className = 'ft-qv__details';
    var clone = info.cloneNode(true);
    var addBtn = clone.querySelector('[data-ft-add]');
    if (addBtn) addBtn.removeAttribute('data-ft-wired');
    right.appendChild(clone);
    grid.appendChild(left);
    grid.appendChild(right);
    initAddButtons(grid);
    qvLastFocus = document.activeElement;
    qvModal.hidden = false;
    lockScroll();
    var closeBtn = qvModal.querySelector('.ft-qv__close');
    if (closeBtn) closeBtn.focus();
    return true;
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.ft-replay')) return;
    var trig = e.target.closest('.ft-chapter__media');
    if (!trig) return;
    var card = trig.closest('[data-ft-card]');
    if (!card) return;
    if (openQv(card)) e.preventDefault();
  });

  function initAll(scope) {
    initAutoReveals(scope);
    initReveals(scope);
    initRevealVideos(scope);
    initAddButtons(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
